import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addFutureAction, editFutureAction } from './store/slice';
import { showToast } from 'Core/redux/toast/slice';
import Modal from 'Core/components/modal/modal';
import FutureActionsAddEditForm from './future-actions-add-edit-form';

const FutureActionsAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(modalData || null);
  const [validated, setValidated] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [showValidation, setShowValidation] = useState(false);

  const isEditMode = Boolean(formData?.toolID);

  useEffect(() => {
    setFormData(modalData);
  }, [modalData]);

  const onChangesForm = (data) => {
    setFormData(data);
  };

  const requiredFields = [
    'toolID',
    'customerName',
    'moldNumber',
    'description',
    'receivedDate',
  ];

  const valid = (payload) => {
    const missingFields = requiredFields.filter(field => {
      return !payload[field] || payload[field].toString().trim() === '';
    });

    setInvalidFields(missingFields);

    if (missingFields.length > 0) {
      dispatch(
        showToast({
          message: `Please fill all required fields: ${missingFields.join(', ')}`,
          type: 'danger',
        }),
      );
      return false;
    }

    return true;
  };

  const footer = () => {
    const onSave = async () => {
      setShowValidation(true);
      if (!valid(formData)) return;

      if (formData.moldInfoID == 0) {
        dispatch(addFutureAction(formData));
      } else {
        dispatch(editFutureAction(formData));
      }
    };

    return (
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
        >
          {isEditMode ? 'Update' : 'Save'}
        </button>
      </div>
    );
  };

  const body = () => {
    return (
      <FutureActionsAddEditForm
        data={formData}
        onChanges={onChangesForm}
        id={formData?.id}
        invalidFields={invalidFields}
        showValidation={showValidation}
        isEditMode={isEditMode}
      />
    );
  };

  const handleClose = () => {
    setValidated(false);
    setInvalidFields([]);
    setShowValidation(false);
    onCloseModal();
  };

  return (
    <Modal
      id="future-actions-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Edit Future Action' : 'Add Future Action'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

export default FutureActionsAddEdit;
